import { tns } from "tiny-slider";
import setModalVideo from "../../../frontend/js/video-modal";

const pageListDelta = 6;
let pageListStartX;
let pageListStartY;

class EmployerTestimonialsList {
    constructor(rootElement) {
        this.rootElement = rootElement;
        this.allItems = [];
        this.currentFilter = "";
        this.slider = null;

        this.storeOriginalItems();

        this.initializeReverseModifiers();
        this.slider = this.activateSlider();

        this.initializeFilterButtons();
        this.initializeVideoButtons();
        this.initializeResizeHandler();
        this.handleInitialShowMoreButtonVisibility();
    }

    storeOriginalItems = () => {
        const listElement = this.rootElement.querySelector(
            ".employer-testimonials-list__list",
        );
        this.allItems = [
            ...listElement.querySelectorAll(
                ".employer-testimonials-list__item",
            ),
        ].map((item) => item.cloneNode(true));
    };

    initializeFilterButtons = () => {
        const filterButtons = [
            ...this.rootElement.querySelectorAll(
                ".employer-testimonials-list__tags .filter-button",
            ),
        ];

        filterButtons.forEach((filterButton) => {
            filterButton.addEventListener("click", () =>
                this.handleFilterButtonOnClick(filterButton),
            );
        });

        this.handleMobileFilterOverflow(filterButtons);
    };

    handleMobileFilterOverflow = (filterButtons) => {
        if (window.innerWidth >= 768) {
            this.hideShowMoreButton();
            filterButtons.forEach((button) => {
                button.style.display = "flex";
            });
            return;
        }

        const container = this.rootElement.querySelector(
            ".employer-testimonials-list__tags",
        );
        if (!container) return;

        let showMoreButton = this.getShowMoreButton(container);

        let totalWidth = 0;
        const containerWidth = container.offsetWidth;
        const showMoreButtonWidth = showMoreButton.offsetWidth || 80;
        let visibleCount = 0;

        filterButtons.forEach((button, index) => {
            if (button.classList.contains("filter-button--static")) {
                const buttonWidth = button.offsetWidth + 32;
                totalWidth += buttonWidth;
                visibleCount++;
                return;
            }

            const buttonWidth = button.offsetWidth + 42;
            if (
                totalWidth + buttonWidth + showMoreButtonWidth <
                containerWidth
            ) {
                totalWidth += buttonWidth;
                visibleCount++;
            } else {
                button.style.display = "none";
            }
        });

        if (visibleCount < filterButtons.length) {
            const hiddenCount = filterButtons.length - visibleCount;
            showMoreButton.textContent = `Visa fler (${hiddenCount})`;
            showMoreButton.style.display = "flex";
            this.setupShowMoreButtonLogic(
                showMoreButton,
                filterButtons,
                visibleCount,
                container,
            );
        } else {
            showMoreButton.style.display = "none";
        }
    };

    getShowMoreButton = (container) => {
        return container.querySelector(".filter-button--show-more");
    };

    hideShowMoreButton = () => {
        const container = this.rootElement.querySelector(
            ".employer-testimonials-list__tags",
        );
        if (container) {
            const showMoreButton = container.querySelector(
                ".filter-button--show-more",
            );
            if (showMoreButton) {
                showMoreButton.style.display = "none";
            }
        }
    };

    setupShowMoreButtonLogic = (
        showMoreButton,
        filterButtons,
        originalVisibleCount,
        container,
    ) => {
        showMoreButton.replaceWith(showMoreButton.cloneNode(true));
        showMoreButton = container.querySelector(".filter-button--show-more");

        let isExpanded = false;
        showMoreButton.addEventListener("click", () => {
            isExpanded = !isExpanded;

            if (isExpanded) {
                filterButtons.forEach((button) => {
                    button.style.display = "flex";
                });
                container.style.flexWrap = "wrap";
                showMoreButton.textContent = "Visa färre";
                showMoreButton.classList.add("filter-button--show-less");
            } else {
                this.recalculateVisibilityOnCollapse(
                    filterButtons,
                    container,
                    showMoreButton,
                );
            }
        });
    };

    initializeReverseModifiers = () => {
        const reverseClass = "employer-testimonials-card--reverse";
        this.rootElement
            .querySelectorAll(".employer-testimonials-card")
            .forEach((card, i) =>
                card.classList.toggle(reverseClass, (i + 1) % 2 === 0),
            );
    };

    handleFilterButtonOnClick = (filterButton) => {
        const workTitle = filterButton.dataset.title || "";
        this.updateActiveFilterButton(filterButton);
        this.filterItems(workTitle);

        if (window.innerWidth < 768) {
            const targetElement = document.querySelector(
                "#employer-testimonials-list-ow",
            );
            if (targetElement) {
                const elementPosition =
                    targetElement.getBoundingClientRect().top +
                    window.pageYOffset;
                window.scrollTo({
                    top: elementPosition - 20,
                    behavior: "smooth",
                });

                if (!targetElement.hasAttribute("tabindex")) {
                    targetElement.setAttribute("tabindex", "-1");
                }

                setTimeout(() => {
                    targetElement.focus();
                }, 500);
            }
        }
    };

    updateActiveFilterButton = (activeButton) => {
        this.rootElement.querySelectorAll(".filter-button").forEach((btn) => {
            btn.classList.remove("filter-button--active");
        });

        activeButton.classList.add("filter-button--active");
    };

    filterItems = (workTitle) => {
        if (this.currentFilter === workTitle) {
            return;
        }

        this.currentFilter = workTitle;

        if (this.slider && this.slider.destroy) {
            this.slider.destroy();
            this.slider = null;
        }

        let filteredItems;
        if (workTitle === "") {
            filteredItems = [...this.allItems];
        } else {
            filteredItems = this.allItems.filter((item) => {
                const card = item.querySelector(".employer-testimonials-card");
                return card && card.dataset.title === workTitle;
            });
        }

        this.updateCarouselItems(filteredItems);
        this.initializeReverseModifiers();
        this.slider = this.activateSlider();
        this.initializeVideoButtons();
    };

    updateCarouselItems = (items) => {
        const listElement = this.rootElement.querySelector(
            ".employer-testimonials-list__list",
        );

        listElement.innerHTML = "";

        items.forEach((item) => {
            listElement.appendChild(item.cloneNode(true));
        });
    };

    activateSlider = () => {
        const listElement = this.rootElement.querySelector(
            ".employer-testimonials-list__list",
        );

        if (listElement && listElement.children.length > 0) {
            return tns({
                container: listElement,
                autoplay: false,
                controls: true,
                nav: false,
                speed: 250,
                mouseDrag: true,
                gutter: 10,
                controlsText: ["", ""],
                loop: false,
                items: 1.15,
                onInit: function (instance) {
                    instance.nextButton.ariaLabel = "Framåt";
                    instance.prevButton.ariaLabel = "Bakåt";
                },
                responsive: {
                    576: {
                        items: 2,
                        gutter: 16,
                    },
                    768: {
                        items: 3,
                        gutter: 24,
                    },
                    1200: {
                        items: 4,
                        gutter: 32,
                    },
                },
                controlsContainer: listElement.parentElement.querySelector(
                    ".employer-testimonials-list__controls",
                ),
            });
        }
        return null;
    };

    initializeVideoButtons = () => {
        const videoButtons = this.rootElement.querySelectorAll(
            ".employer-testimonials-card__video-button_wrapper",
        );

        videoButtons.forEach((button) => {
            button.addEventListener("mousedown", (event) => {
                pageListStartX = event.pageX;
                pageListStartY = event.pageY;
            });

            button.addEventListener("mouseup", (event) => {
                if (event.which !== 1) return;

                const diffX = Math.abs(event.pageX - pageListStartX);
                const diffY = Math.abs(event.pageY - pageListStartY);

                if (diffX < pageListDelta && diffY < pageListDelta) {
                    const videoUrl = button.dataset.videoUrl;
                    if (!videoUrl) return;

                    const url = new URL(videoUrl);
                    const host = url.hostname.includes("vimeo")
                        ? "vimeo"
                        : url.hostname.includes("youtube")
                          ? "youtube"
                          : "qbank";

                    const videoId =
                        host === "vimeo"
                            ? url.pathname.split("/").pop()
                            : host === "youtube"
                              ? url.searchParams.get("v")
                              : null;

                    const obj = {
                        videoHost: host,
                        videoId,
                        videoUrl: host === "qbank" ? url.href : null,
                    };

                    console.log("obj", obj);

                    setModalVideo(obj);
                }
            });
        });
    };

    initializeResizeHandler = () => {
        let resizeTimeout;
        this.resizeHandler = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.reinitializeFilterButtons();
            }, 250);
        };
        window.addEventListener("resize", this.resizeHandler);
    };

    reinitializeFilterButtons = () => {
        const filterButtons = [
            ...this.rootElement.querySelectorAll(
                ".employer-testimonials-list__tags .filter-button:not(.filter-button--show-more)",
            ),
        ];

        filterButtons.forEach((button) => {
            if (!button.classList.contains("filter-button--static")) {
                button.style.display = "flex";
            }
        });

        const container = this.rootElement.querySelector(
            ".employer-testimonials-list__tags",
        );
        if (container) {
            container.style.flexWrap = "nowrap";
        }

        this.resetShowMoreButtonState();

        this.handleMobileFilterOverflow(filterButtons);
    };

    resetShowMoreButtonState = () => {
        const container = this.rootElement.querySelector(
            ".employer-testimonials-list__tags",
        );
        if (container) {
            const showMoreButton = container.querySelector(
                ".filter-button--show-more",
            );
            if (showMoreButton) {
                showMoreButton.textContent = "Visa fler";
                showMoreButton.classList.remove("filter-button--show-less");
                showMoreButton.style.display = "none";
            }
        }
    };

    handleInitialShowMoreButtonVisibility = () => {
        if (window.innerWidth >= 768) {
            this.hideShowMoreButton();
        }
    };

    recalculateVisibilityOnCollapse = (
        filterButtons,
        container,
        showMoreButton,
    ) => {
        filterButtons.forEach((button) => {
            if (!button.classList.contains("filter-button--static")) {
                button.style.display = "flex";
            }
        });

        let totalWidth = 0;
        const containerWidth = container.offsetWidth;
        const showMoreButtonWidth = showMoreButton.offsetWidth || 80;
        let newVisibleCount = 0;

        filterButtons.forEach((button, index) => {
            if (button.classList.contains("filter-button--static")) {
                const buttonWidth = button.offsetWidth + 32;
                totalWidth += buttonWidth;
                newVisibleCount++;
                return;
            }

            const buttonWidth = button.offsetWidth + 42;
            if (
                totalWidth + buttonWidth + showMoreButtonWidth <
                containerWidth
            ) {
                totalWidth += buttonWidth;
                newVisibleCount++;
            } else {
                button.style.display = "none";
            }
        });

        container.style.flexWrap = "nowrap";

        const hiddenCount = filterButtons.filter(
            (button) =>
                !button.classList.contains("filter-button--static") &&
                button.style.display === "none",
        ).length;
        showMoreButton.textContent = `Visa flera (${hiddenCount})`;
        showMoreButton.classList.remove("filter-button--show-less");
    };

    destroy = () => {
        if (this.slider && this.slider.destroy) {
            this.slider.destroy();
        }

        window.removeEventListener("resize", this.resizeHandler);
    };
}

document.addEventListener("DOMContentLoaded", function () {
    [...document.querySelectorAll(".employer-testimonials-list")].forEach(
        (rootElement) => {
            new EmployerTestimonialsList(rootElement);
        },
    );
});
